<!--

 -->

<template>
  <oxd-alert
    :show="true"
    type="warn"
    :message="$t('general.no_records_found')"
  ></oxd-alert>
</template>

<script>
import {OxdAlert} from '@ohrm/oxd';

export default {
  components: {
    'oxd-alert': OxdAlert,
  },
};
</script>
